"use client";

import React from "react";

import { LDProvider, ProviderConfig } from "launchdarkly-react-client-sdk";

import {
  LAUNCH_DARKLY_DEFAULT_FLAGS,
  DEFAULT_REACT_OPTIONS,
} from "@stadium/services/launch-darkly/constants";

const defaultObj = {};

type FeatureFlagProviderProps = {
  clientSideID: string;
  children: React.ReactNode;
  configurations?: ProviderConfig;
  isReadyForInit?: boolean;
};

export const FeatureFlagProvider = ({
  clientSideID = "",
  children,
  configurations,
  isReadyForInit,
}: FeatureFlagProviderProps) => {
  const config = isReadyForInit ? configurations : defaultObj;
  return (
    <LDProvider
      clientSideID={clientSideID}
      flags={LAUNCH_DARKLY_DEFAULT_FLAGS}
      deferInitialization
      reactOptions={DEFAULT_REACT_OPTIONS}
      {...config}
    >
      {children}
    </LDProvider>
  );
};
